import React from "react";

import styles from "../assets/styles/FinlandSideCol.module.scss";

const FinlandSideCol = ({ headline, description, image }) => {
	return (
		<div className={styles.root}>
			<div className={styles.container}>
				<img className={styles.image} src={image} alt="" />
				<div className={styles.headline}>
					<h2>{headline}</h2>
				</div>
				<div className={styles.description}>
					<p>{description}</p>
				</div>
			</div>
		</div>
	);
};

export default FinlandSideCol;
